import { HealthSeverity } from '@shure/shared/angular/data-access/system-api/models';

export const UNGROUPED_GROUP_ID = 'ungrouped';
export const UNGROUPED_GROUP_TRANSLATION_KEY = 'cloud.device-management.inventory.not-in-a-group';

export interface Group {
	id: string;
	name: string;
	parentId?: string;
	health: {
		worstSeverity?: HealthSeverity;
	};
}
